import React from 'react';
import Panel from '../../components/ui/Panel';

const ButtonAPIReference: React.FC = () => {
  return (
    <div className="space-y-8">
      <h1 className="text-3xl text-osrs-gold font-bold uppercase mb-4">Button API Reference</h1>
      
      <section>
        <h2 className="text-2xl text-osrs-gold font-bold mb-4">Props</h2>
        <Panel>
          <div className="space-y-6">
            <div>
              <h3 className="text-xl text-osrs-gold font-bold mb-2">children</h3>
              <p className="text-osrs-yellow mb-2">Type: <code className="text-osrs-chat">React.ReactNode</code></p>
              <p className="text-osrs-yellow">The content to be rendered inside the button.</p>
            </div>

            <div>
              <h3 className="text-xl text-osrs-gold font-bold mb-2">variant</h3>
              <p className="text-osrs-yellow mb-2">Type: <code className="text-osrs-chat">'primary' | 'secondary' | 'danger'</code></p>
              <p className="text-osrs-yellow mb-2">Default: <code className="text-osrs-chat">'primary'</code></p>
              <p className="text-osrs-yellow">The visual style variant of the button.</p>
            </div>

            <div>
              <h3 className="text-xl text-osrs-gold font-bold mb-2">size</h3>
              <p className="text-osrs-yellow mb-2">Type: <code className="text-osrs-chat">'small' | 'medium' | 'large'</code></p>
              <p className="text-osrs-yellow mb-2">Default: <code className="text-osrs-chat">'medium'</code></p>
              <p className="text-osrs-yellow">The size of the button.</p>
            </div>

            <div>
              <h3 className="text-xl text-osrs-gold font-bold mb-2">disabled</h3>
              <p className="text-osrs-yellow mb-2">Type: <code className="text-osrs-chat">boolean</code></p>
              <p className="text-osrs-yellow mb-2">Default: <code className="text-osrs-chat">false</code></p>
              <p className="text-osrs-yellow">Whether the button is disabled.</p>
            </div>

            <div>
              <h3 className="text-xl text-osrs-gold font-bold mb-2">fullWidth</h3>
              <p className="text-osrs-yellow mb-2">Type: <code className="text-osrs-chat">boolean</code></p>
              <p className="text-osrs-yellow mb-2">Default: <code className="text-osrs-chat">false</code></p>
              <p className="text-osrs-yellow">Whether the button should take up the full width of its container.</p>
            </div>

            <div>
              <h3 className="text-xl text-osrs-gold font-bold mb-2">className</h3>
              <p className="text-osrs-yellow mb-2">Type: <code className="text-osrs-chat">string</code></p>
              <p className="text-osrs-yellow">Additional CSS classes to apply to the button.</p>
            </div>
          </div>
        </Panel>
      </section>

      <section>
        <h2 className="text-2xl text-osrs-gold font-bold mb-4">Event Props</h2>
        <Panel>
          <div className="space-y-6">
            <div>
              <h3 className="text-xl text-osrs-gold font-bold mb-2">onClick</h3>
              <p className="text-osrs-yellow mb-2">Type: <code className="text-osrs-chat">(event: React.MouseEvent) {'=>'} void</code></p>
              <p className="text-osrs-yellow">Called when the button is clicked.</p>
            </div>

            <div>
              <h3 className="text-xl text-osrs-gold font-bold mb-2">onMouseEnter</h3>
              <p className="text-osrs-yellow mb-2">Type: <code className="text-osrs-chat">(event: React.MouseEvent) {'=>'} void</code></p>
              <p className="text-osrs-yellow">Called when the mouse enters the button.</p>
            </div>

            <div>
              <h3 className="text-xl text-osrs-gold font-bold mb-2">onMouseLeave</h3>
              <p className="text-osrs-yellow mb-2">Type: <code className="text-osrs-chat">(event: React.MouseEvent) {'=>'} void</code></p>
              <p className="text-osrs-yellow">Called when the mouse leaves the button.</p>
            </div>
          </div>
        </Panel>
      </section>

      <section>
        <h2 className="text-2xl text-osrs-gold font-bold mb-4">TypeScript Interface</h2>
        <Panel>
          <pre className="bg-osrs-black p-4 rounded font-mono text-sm text-osrs-yellow overflow-x-auto">
{`interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'danger';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  fullWidth?: boolean;
  className?: string;
  onClick?: (event: React.MouseEvent) => void;
  onMouseEnter?: (event: React.MouseEvent) => void;
  onMouseLeave?: (event: React.MouseEvent) => void;
}`}
          </pre>
        </Panel>
      </section>
    </div>
  );
};

export default ButtonAPIReference; 